<template>
    <div :class="['payment-result-page', 'payment-result-page--success']">
        <div class="payment-result-card">
            <div class="payment-result-icon payment-result-icon--success">
                <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="20 6 9 17 4 12"/></svg>
            </div>
            <div class="payment-result-title">{{ $t('common.billing.externalPaymentSuccess') }}</div>
            <div v-if="orderId" class="payment-result-order">#{{ orderId }}<template v-if="orderName"> &middot; {{ orderName }}</template></div>
            <div v-if="amount" class="payment-result-amount">{{ formatPrice(amount) }}&#8378;</div>
            <button class="payment-result-btn" @click="goToPanel">{{ $t('common.billing.openBillingPanel') }}</button>
        </div>
    </div>
</template>

<script>
import billingService from '@/components/billing/billingService'

export default {
    layout: 'auth',
    computed: {
        orderId() {
            return this.$route.query.order_id || null
        },
        orderName() {
            return this.$route.query.order_name || null
        },
        amount() {
            return this.$route.query.amount ? Number(this.$route.query.amount) : null
        },
    },
    methods: {
        formatPrice: billingService.formatPrice,
        goToPanel() {
            const orderId = this.orderId ? Number(this.orderId) : null
            this.$router.push('/dashboard')
            this.$nextTick(() => {
                if (orderId) {
                    billingService.selectOrder(orderId)
                }
            })
        },
    },
}
</script>

<style scoped>
.payment-result-page {
    position: fixed;
    inset: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 24px;
}

.payment-result-page--success {
    background: linear-gradient(135deg, #ECFDF5 0%, #D1FAE5 50%, #A7F3D0 100%);
}

html.dark .payment-result-page--success {
    background: linear-gradient(135deg, #022c22 0%, #064e3b 50%, #065f46 100%);
}

html.midnight .payment-result-page--success {
    background: linear-gradient(135deg, #1a1510 0%, #2a1f14 50%, #3a2a1a 100%);
}

.payment-result-card {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    padding: 48px 40px 36px;
    border-radius: 16px;
    max-width: 420px;
    width: 100%;
    background: #fff;
    box-shadow: 0 24px 64px rgba(0, 0, 0, 0.1);
}

html.dark .payment-result-card {
    background: #1C1D22;
    box-shadow: 0 24px 64px rgba(0, 0, 0, 0.5);
}

html.midnight .payment-result-card {
    background: #1E1B17;
    box-shadow: 0 24px 64px rgba(0, 0, 0, 0.5);
}

.payment-result-icon {
    width: 96px;
    height: 96px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 20px;
    animation: resultPop 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);
}

.payment-result-icon--success {
    background: rgba(16, 185, 129, 0.12);
    color: #10B981;
}

html.midnight .payment-result-icon--success {
    background: rgba(200, 134, 60, 0.12);
    color: #C8863C;
}

.payment-result-title {
    font-size: 20px;
    font-weight: 700;
    color: #111827;
    margin-bottom: 8px;
}

html.dark .payment-result-title {
    color: #F3F4F6;
}

html.midnight .payment-result-title {
    color: #F0E6D6;
}

.payment-result-order {
    font-size: 13px;
    color: #6B7280;
    margin-bottom: 4px;
}

html.dark .payment-result-order {
    color: #9CA3AF;
}

html.midnight .payment-result-order {
    color: #A89880;
}

.payment-result-amount {
    font-size: 28px;
    font-weight: 800;
    color: #10B981;
    font-variant-numeric: tabular-nums;
    margin-top: 8px;
    margin-bottom: 24px;
}

html.midnight .payment-result-amount {
    color: #C8863C;
}

.payment-result-btn {
    padding: 10px 28px;
    border-radius: 8px;
    font-size: 13px;
    font-weight: 600;
    border: none;
    cursor: pointer;
    transition: all 0.15s;
    background: #10B981;
    color: #fff;
}

.payment-result-btn:hover {
    background: #059669;
}

html.midnight .payment-result-btn {
    background: #C8863C;
}

html.midnight .payment-result-btn:hover {
    background: #A87030;
}

@keyframes resultPop {
    0% { transform: scale(0); opacity: 0; }
    60% { transform: scale(1.15); }
    100% { transform: scale(1); opacity: 1; }
}
</style>
